import * as i0 from '@angular/core';
import { inject, Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { NgDocCopyButtonComponent } from '@ng-doc/app/components/copy-button';
import { NgDocIconComponent, NgDocButtonIconComponent } from '@ng-doc/ui-kit';
import { LOCATION } from '@ng-web-apis/common';
let NgDocHeadingAnchorComponent = /*#__PURE__*/(() => {
  class NgDocHeadingAnchorComponent {
    constructor() {
      this.classes = [];
      this.location = inject(LOCATION);
    }
    get href() {
      const {
        origin,
        pathname
      } = this.location;
      return `${origin}${pathname}#${this.anchor}`;
    }
    static {
      this.ɵfac = function NgDocHeadingAnchorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocHeadingAnchorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocHeadingAnchorComponent,
        selectors: [["ng-doc-heading-anchor"]],
        hostVars: 2,
        hostBindings: function NgDocHeadingAnchorComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.classes);
          }
        },
        inputs: {
          anchor: "anchor",
          classes: "classes"
        },
        decls: 2,
        vars: 1,
        consts: [[3, "text"], ["icon", "link-2"]],
        template: function NgDocHeadingAnchorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ng-doc-copy-button", 0);
            i0.ɵɵelement(1, "ng-doc-icon", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("text", ctx.href);
          }
        },
        dependencies: [NgDocIconComponent, NgDocCopyButtonComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NgDocHeadingAnchorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocHeadingAnchorComponent };
